import React, { useRef } from 'react';
import { ThemeProvider, StyledEngineProvider, CssBaseline } from '@mui/material';
import AppRouter from "./routes/AppRouter/AppRouter";
import theme from "./assets/theme/themeConfig";

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import esLocale from "date-fns/locale/es"; // nuevo alias

const App = () => {
  const innerRef = useRef();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
          <AppRouter onError={(error) => console.log(error)} ref={innerRef} />
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
